module.exports = __webpack_public_path__ + "static/media/mitsubishi-checkmark.57f4fcd4.svg";